import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import { LocalizedMessage } from '../../utilites/translate';
import ValidateError from '../../utilites/validate/ValidateError';

//@todo split to container and error messages!!1
class ErrorContainer extends React.Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    displayLabel: PropTypes.bool.isRequired,
    label: PropTypes.any,
    labelStyle: PropTypes.object,
    errorLabelStyle: PropTypes.object,
    touched: PropTypes.bool,
    style: PropTypes.object,
    error: PropTypes.any
  };

  static contextTypes = {
    muiTheme: PropTypes.object
  };

  getStyle() {
    let { muiTheme } = this.context;

    return {
      label: {
        marginBottom: 10,
        display: 'block',
        fontWeight: 'bold',
        color: muiTheme.textField.hintColor
      },
      require: {
        color: muiTheme.palette.accent1Color
      },
      error: {
        fontSize: 12,
        lineHeight: 1,
        paddingTop: 7,
        color: muiTheme.textField.errorColor,
        ...this.props.errorLabelStyle
      }
    };
  }

  render() {
    let { label, touched, error = [], children, style, required, displayLabel, labelStyle } = this.props;
    let errors = touched ? error : [];
    let hasError = errors.length > 0;
    let internalStyle = this.getStyle();
    let combineStyle = Object.assign({ marginBottom: 30 }, style);

    if (hasError) {
      internalStyle.label.color = internalStyle.error.color;
    }

    label = (<span>{label}{required ? <span style={internalStyle.require}> *</span> : null}</span>);

    return (
      <div style={combineStyle}>
        { displayLabel ? <label htmlFor={this._id} style={Object.assign({}, internalStyle.label, labelStyle)}>{label}</label> : null }
        { children }
        { this.renderError() }
      </div>
    );
  }

  renderMessage(message, index) {
    if (message instanceof LocalizedMessage) {
      return ( <FormattedMessage key={index} id={message.msg} values={message.values}/> );
    } else if(message instanceof ValidateError){
      return ( <FormattedMessage key={index} id={message.msg} values={message.data}/> );
    } else {
      return ( <div key={index}>{message}</div> );
    }
  }

  renderError() {
    let { touched, error = [] } = this.props;
    let errorMessage = touched
      ? this.getErrorMessage(error)
      : undefined;

    let hasError = errorMessage !== undefined;
    let internalStyle = this.getStyle();

    if (hasError) {
      return (
        <div style={internalStyle.error}>
          {this.renderMessage(errorMessage, 1)}
        </div>
      );
    } else {
      return null;
    }
  }

  getErrorMessage(error) {
    switch (typeof error) {
      case 'object':
      case 'array':
        return error[0] || error;
      default:
        return undefined;
    }
  }
}

ErrorContainer.defaultProps = {
  id: 'default',
  labelStyle: {},
  displayLabel: true,
  touched: false
};

export default ErrorContainer;




// WEBPACK FOOTER //
// ./src/components/form/ErrorContainer.jsx